import React from 'react';
import css from './ToggleSwitch.module.scss';

const ToggleSwitch = ({ toggleName, checked, onChange }) => (
  <>
    <input
      data-testid="toggle-switch"
      type="checkbox"
      className={css.switchCheckbox}
      name={toggleName}
      id={toggleName}
      onChange={onChange}
      checked={checked}
      aria-checked={checked}
    />
    <label
      className={`${css.toggleSwitchLabel} ${checked ? css.active : ''}`}
      htmlFor={toggleName}
    >
      <span
        data-testid="toggle-button"
        className={`${css.switchButton} ${checked ? css.active : ''}`}
      />
    </label>
  </>
);

export default ToggleSwitch;
